import styled from 'styled-components';
import View from '../View';

const Body = styled(View)`
  margin: 16px 24px;
  background-color: #fff;
  flex: 1;
  width: 100%;
  overflow: auto;
`;

export default Body;
